import React from 'react';
import { Global, css } from '@emotion/core';

import bebasNeueRegular from './fonts/BebasNeue-Regular.ttf';

import avenirNextBold from './fonts/AvenirNext-Bold.woff2';

export const FONT_FAMILY_BEBAS_NEUE = 'BebasNeue';
export const FONT_FAMILY_AVENIR_NEXT = 'AvenirNext';
export const FONT_FAMILY_INTER = 'Inter';

export function Fonts() {
	const styles = css`
		@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&display=swap');

		body {
			-webkit-font-smoothing: antialiased;
		}

		a {
			line-height: normal;
		}

		/* Bebas Neue font */
		@font-face {
			font-family: ${FONT_FAMILY_BEBAS_NEUE};
			src: url('${bebasNeueRegular}') format('truetype');
			font-display: swap;
			font-weight: 400;
		}

		/* Avenir Next fonts */
		@font-face {
			font-family: ${FONT_FAMILY_AVENIR_NEXT};
			src: url('${avenirNextBold}') format('woff2');
			font-display: swap;
			font-weight: 700;
		}
	`;

	return <Global styles={styles} />;
}
